export default function SpinningLoader({
  loaderContainerMessage,
  loaderMessage,
  variant = "page",
}: {
  loaderContainerMessage?: string;
  loaderMessage?: string;
  variant?: "page" | "container";
}) {
  return (
    <div
      className={`loader-container ${variant === "container" ? "fill" : "page"}`}
      aria-live="assertive"
      aria-label={loaderContainerMessage}
      data-testid="spinning-loader"
    >
      <div className="loader" aria-live="assertive" aria-label={loaderMessage}></div>
    </div>
  );
}
